import { Injectable } from '@angular/core';
import { RoutePlannerDataModel, AALocationModel } from 'src/app/modules/route-planner/models/route-model';
import { TrafficNewsModel } from 'src/app/modules/traffic-news/models/traffic-news-model';
import { MapsHotelsModel } from 'src/app/modules/maps-hotels/models/maps-hotels-model';
import { AAConstant } from 'src/app/core/models/constants';

@Injectable({
  providedIn: 'root'
})
export class RouteDataStoreService {
  public readonly currentLocation: AALocationModel = new AALocationModel(AAConstant.CURRENT_LOCATION);

  // route planner
  public readonly routeDataModel: RoutePlannerDataModel = new RoutePlannerDataModel();
  public readonly fromLocation: AALocationModel;
  public readonly toLocation: AALocationModel;
  public readonly viaRoutes: Array<AALocationModel>;

  // traffic news
  public readonly trafficNewsModel: TrafficNewsModel = new TrafficNewsModel();

  // maps & hotels
  public readonly mapsHotelsModel: MapsHotelsModel = new MapsHotelsModel();

  constructor() {
    this.fromLocation = this.routeDataModel.FromLocation;
    this.toLocation = this.routeDataModel.ToLocation;
  }
}
